<div class="equipements">
    <app-pop-up-info-properties [datas]="data"></app-pop-up-info-properties>
</div>
